import React from 'react';
import PropTypes from 'prop-types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export const FeatureAvailableIcon = ({ available }) => (available ? <CheckCircleIcon  sx={{ color:'#9acb45' }} /> : <HighlightOffIcon color={'primary'} />);


FeatureAvailableIcon.propTypes = {
  available: PropTypes.bool
};

FeatureAvailableIcon.defaultProps={
  available: false
};